//#region IMPORT
import React, { useState, useEffect } from 'react';
/** Services Import */
/** Components */
import NOT_BASIC_01_01 from './NOT_BASIC_01_01';
import { Loading } from '../../../../Components/MUIs';
import dayjs from 'dayjs';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import { useSearch1, useDelete1 } from './NOT_BASIC_01_01_QUERY';
import { useSave } from '../../../../hooks/useSaveN';
import { NOT_BASIC_01_01_Schema } from './NOT_BASIC_01_01_Schema';
import useDelete from '../../../../hooks/useDeleteN';
import useFileUpload from '../../../../hooks/useFileUpload';
//#endregion

//#region 상수
const SCREEN_MENU_ID = 'Notice1';
//#endregion

function NOT_BASIC_01_01F() {
  //#region 변수
  const { state } = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [dateValue, setDateValue] = useState(dayjs().format('YYYY-MM-DD')); //조회조건 조회일자
  const [inputs, setInputs] = useState({
    chaebunNo: '', //공지사항코드
    title: '', //제목
    comment: '', //내용
    gubun: '', //구분
    gubunDtl: '', //구분상세
    gubunDtlNm: '', //구분상세명
    endDate: dayjs().format('YYYY-MM-DD'), //종료일
  });

  const [dialogToggle1, setDialogToggle1] = useState({
    open: false,
    title: '',
    content: <></>,
    contentText: '',
    actions: <></>,
  });

  const { DeleteLogicFile } = useFileUpload({
    oldFilePathField: 'filePath',
    newFileNameField: 'saveName',
    getTargetPath: (item, custCd) => {
      return `NoticeBoard/${state?.data?.coCd}/NOT_BASIC_01_01`;
    },
  });
  //#endregion

  //#region 초기화
  const Init = async () => {
    try {
      setInputs(state?.data);
      if (state?.data?.chaebunNo) {
        await Search1({
          chaebunNo: state?.data?.chaebunNo,
        });
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    Init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //#endregion

  //#region 쿼리
  // 조회
  const { run: Search1 } = useSearch1({
    onSuccess: (rows) => {
      const mappedRows = rows.map((f) => ({
        ...f,
        PREVIEW: /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(f.fileName)
          ? `${Global.base.fileUrl}/${f.filePath}`
          : null,
        deleted: false,
      }));
      setUploadedFiles(mappedRows);
    },
  });

  // 삭제
  const delete1 = useDelete1();
  const deleteHandler1 = useDelete({
    deleteMutation: delete1,
    deletedRowData: [inputs],
  });

  // 저장
  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    schema: NOT_BASIC_01_01_Schema,
    getChangedRows: () => [],
    getDeletedRows: () => [inputs],
    requestDelete: deleteHandler1.DeleteLogic,
    afterDeleteRow: async (item, { index, savedRows, userInfo }) => {
      DeleteLogicFile(uploadedFiles);
      navigate('/NoticeBoard', {
        state: { coCd: state?.coCd },
      });
    },
  });
  //#endregion

  //#region 나머지 함수
  // 파일 다운로드
  const DownloadLogic1 = async (_data) => {
    if (!_data.filePath) {
      dispatch(
        showSnackbar({ message: '파일이 존재하지 않습니다.', type: 'warning' })
      );
      return;
    }

    try {
      const filePath = fixUrl(_data.filePath);
      const fileName = _data.fileName || 'downloaded_file';

      const params = {
        FileName: fileName,
        Url: filePath,
      };

      await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        params
      ).then((result) => {
        const contentType = result?.headers?.['content-type'];
        const blobData = result?.data;

        if (!blobData || !contentType) {
          dispatch(
            showSnackbar({
              message: `"${fileName}" 다운로드 응답이 비정상입니다.`,
              type: 'error',
            })
          );
          return;
        }

        // 1) Blob → Object URL 생성
        const blob = new Blob([blobData], { type: contentType });
        const url = window.URL.createObjectURL(blob);

        // 2) <a> 태그 만들어서 클릭 트리거
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName; // 저장될 파일명
        document.body.appendChild(a);
        a.click();

        // 3) 정리
        a.remove();
        window.URL.revokeObjectURL(url);

        dispatch(
          showSnackbar({
            message: `"${fileName}" 다운로드 완료`,
            type: 'success',
          })
        );
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  const fixUrl = (url) => {
    if (!url || typeof url !== 'string') return ''; // 또는 적절한 fallback
    const parts = url.split('/');
    const fileName = parts.pop(); // 파일 이름 분리
    const encodedFileName = encodeURIComponent(fileName);
    return [...parts, encodedFileName].join('/');
  };
  //#endregion

  return (
    <div className="wrap">
      <NOT_BASIC_01_01
        userInfo={userInfo}
        dateValue={dateValue}
        setDateValue={setDateValue}
        lanInfo={lanInfo}
        navigate={navigate}
        Save1={Save1}
        inputs={inputs}
        setInputs={setInputs}
        state={state}
        DownloadLogic1={DownloadLogic1}
        uploadedFiles={uploadedFiles}
        dialogToggle1={dialogToggle1}
        setDialogToggle1={setDialogToggle1}
      />
      <Loading open={loading} />
    </div>
  );
}

export default NOT_BASIC_01_01F;
